export const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
export const isNode = !isBrowser;
export const isIOS = vendor => vendor === 'Apple';
export const isAndroid = vendor => !!vendor && !isIOS(vendor);
export const isSafari = userAgent => /^((?!chrome|android).)*safari/i.test(userAgent);
export const getIEVersion = userAgent => {
  const e = userAgent;
  const n = e.indexOf('MSIE ');
  if (n > 0) return parseInt(e.substring(n + 5, e.indexOf('.', n)), 10);

  if (e.indexOf('Trident/') > 0) {
    const n = e.indexOf('rv:');
    return parseInt(e.substring(n + 3, e.indexOf('.', n)), 10);
  }

  const t = e.indexOf('Edge/');
  return t > 0 && parseInt(e.substring(t + 5, e.indexOf('.', t)), 10);
};
export const connectionType = () => {
  var _connection$effective;

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  return connection == null ? void 0 : (_connection$effective = connection.effectiveType) == null ? void 0 : _connection$effective.toUpperCase();
};